<geaui-page-header pageTitle="Oil Separator Calculation" [hasBackArrow]="false" [withSidebar]="true">

  <div class="TopRightOptions">
    
    Units:
    <mat-radio-group [(ngModel)]="isUsUnits" class="UnitsRadioButtons">
      <mat-radio-button [value]="true">US</mat-radio-button>
      <mat-radio-button [value]="false">SI</mat-radio-button>
    </mat-radio-group>

    <button class="geaui-button-primary TopRightButton" (click)="openLoadDialog()">Open</button>
    <button class="geaui-button-primary TopRightButton" (click)="openSaveDialog()">Save As...</button>
    <button *ngIf="loadedCalculation" class="geaui-button-primary TopRightButton" (click)="saveCalculation()">Save</button>
    <button *ngIf="loadedCalculation" class="geaui-button-primary TopRightButton" (click)="openNotes()">Notes</button>

  </div>
</geaui-page-header>

<div *ngIf="loadedCalculation" class="ProjectNumberHeader">
  <span>{{ saveProjectNumber }}</span>
  <br />
</div>

<div *ngIf="!isLoaded" class="Content">
  <h3 class="Heading">Loading...</h3>
</div>
<div *ngIf="isLoaded" class="Content">

  <span class="VerticalBlock">
    <h3 class="Heading">Input </h3>
    <br>

    <span class="InputBlock">
      <span class="Label">Refrigerant:</span>
      <component-drop-down class="Value" [ViewModel]="viewModel.InputViewModel.Refrigerant" (ValueChange)="onChange($event)"></component-drop-down>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Oil Type:</span>
      <component-drop-down class="Value" [ViewModel]="viewModel.InputViewModel.OilType" (ValueChange)="onChange($event)"></component-drop-down>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Application:</span>
      <component-drop-down class="Value" [ViewModel]="viewModel.InputViewModel.Application" (ValueChange)="onChange($event)"></component-drop-down>
      <span class="Unit"></span>
    </span>
  </span>

  <span *ngIf="loadedCalculation" class="VerticalBlock">
    <h3 class="Heading">Save </h3>
    <br>

    <span class="InputBlock">
      <span class="Label">Project #:</span>
      <component-text-box class="Value" [(Value)]="saveProjectNumber"></component-text-box>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Name:</span>
      <component-text-box class="Value" [(Value)]="saveName"></component-text-box>
      <span class="Unit"></span>
    </span>
    <br>

    <span class="InputBlock">
      <!-- <span class="Label">Comments:</span>
      <component-text-box class="Value" [(Value)]="saveComments"></component-text-box>
      <span class="Unit"></span> -->
    </span>
  </span>
  <br>

  <span class="VerticalBlock">
    <h3 class="Heading">Design Condensing </h3>
    <br>

    <span class="InputBlock">
      <span class="Label">Discharge Temp:</span>
      <measurement-text-box class="Value" [(Value)]="viewModel.InputViewModel.DesignCondensingTemperature.Value" (ValueChange)="onChange($event)" [Context]="MeasurementContext.Temperature" [IsUsUnits]="isUsUnits"></measurement-text-box>
      <span class="Unit">{{ getUnitText(MeasurementContext.Temperature) }}</span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Discharge Pressure:</span>
      <measurement-text-box class="Value" [(Value)]="viewModel.InputViewModel.DesignCondensingPressure.Value" (ValueChange)="onChange($event)" [Context]="MeasurementContext.AbsPressure" [IsUsUnits]="isUsUnits"></measurement-text-box>
      <span class="Unit">{{ getUnitText(MeasurementContext.AbsPressure) }}</span>
    </span>
    <br>

    <span class="InputBlock">
      <span class="Label">Discharge Mass Flow:</span>
      <measurement-text-box class="Value" [(Value)]="viewModel.InputViewModel.DesignCondensingMassFlow.Value" (ValueChange)="onChange($event)" [Context]="MeasurementContext.MassFlow" [IsUsUnits]="isUsUnits"></measurement-text-box>
      <span class="Unit">{{ getUnitText(MeasurementContext.MassFlow) }}</span>
    </span>
  </span>

  <span class="VerticalBlock">
    <h3 class="Heading">Minimum Condensing </h3>
    <br>

    <span class="InputBlock">
      <span class="Label">Discharge Temp:</span>
      <measurement-text-box class="Value" [(Value)]="viewModel.InputViewModel.MinimumCondensingTemperature.Value" (ValueChange)="onChange($event)" [Context]="MeasurementContext.Temperature" [IsUsUnits]="isUsUnits"></measurement-text-box>
      <span class="Unit">{{ getUnitText(MeasurementContext.Temperature) }}</span>
    </span>
    <br>
    
    <span class="InputBlock">
      <span class="Label">Discharge Pressure:</span>
      <measurement-text-box class="Value" [(Value)]="viewModel.InputViewModel.MinimumCondensingPressure.Value" (ValueChange)="onChange($event)" [Context]="MeasurementContext.AbsPressure" [IsUsUnits]="isUsUnits"></measurement-text-box>
      <span class="Unit">{{ getUnitText(MeasurementContext.AbsPressure) }}</span>
    </span>
    <br>
    
    <span class="InputBlock">
      <span class="Label">Discharge Mass Flow:</span>
      <measurement-text-box class="Value" [(Value)]="viewModel.InputViewModel.MinimumCondensingMassFlow.Value" (ValueChange)="onChange($event)" [Context]="MeasurementContext.MassFlow" [IsUsUnits]="isUsUnits"></measurement-text-box>
      <span class="Unit">{{ getUnitText(MeasurementContext.MassFlow) }}</span>
    </span>
  </span>
  <br>

  <h3 class="Heading">Vessels </h3>
  <h3 class="TableIcons">
    <button class="hrt-export-btn" (click)="exportDebugDataToCsv()">
      <span class="csv-text">CSV</span>
      <mat-icon>download</mat-icon>
    </button>
  </h3>
  <br>

  <table>
    <thead>
      <tr>
        <th></th>
        <th *ngIf="viewModel.OutputViewModel.ShowErrorColumn.Value"></th>
        <th colspan="5">Vessel</th>
        <th colspan="2">Velocities &#64; Design</th>
        <th colspan="2">Velocities &#64; Min Cond</th>
        <th colspan="3">Oil</th>
        <th colspan="5">Coalescer</th>
        <th></th>
      </tr>
      <tr>
        <th></th>
        <th *ngIf="viewModel.OutputViewModel.ShowErrorColumn.Value"></th>
        <th matTooltip="Nominal Diameter / Orientation">Dia - Orientation</th>
        <th>Length</th>
        <th matTooltip="Wall Thickness">Thick</th>
        <th matTooltip="Cross Sectional Area">CSA</th>
        <th matTooltip="Free Flow Area">FFA</th>
        <th>Actual</th>
        <th>Max</th>
        <th>Actual</th>
        <th>Max</th>
        <th>Level</th>
        <th matTooltip="Cross Sectional Area">CSA</th>
        <th>Charge</th>
        <th>Type</th>
        <th>Area</th>
        <th>Qty</th>
        <th>Rods</th>
        <th>Rows</th>
        <th></th>
      </tr>
      <tr style="font-style: italic; background-color: #f5f5f5;">
        <td></td>
        <td *ngIf="viewModel.OutputViewModel.ShowErrorColumn.Value"></td>
        <td></td>
        <td>{{ getUnitText(MeasurementContext.Length) }}</td>
        <td>{{ getUnitText(MeasurementContext.Length) }}</td>
        <td>{{ getUnitText(MeasurementContext.Area) }}</td>
        <td>{{ getUnitText(MeasurementContext.Area) }}</td>
        <td>{{ getUnitText(MeasurementContext.SeparatorVelocity) }}</td>
        <td>{{ getUnitText(MeasurementContext.SeparatorVelocity) }}</td>
        <td>{{ getUnitText(MeasurementContext.SeparatorVelocity) }}</td>
        <td>{{ getUnitText(MeasurementContext.SeparatorVelocity) }}</td>
        <td>{{ getUnitText(MeasurementContext.Length) }}</td>
        <td>{{ getUnitText(MeasurementContext.Area) }}</td>
        <td>{{ getUnitText(MeasurementContext.LiquidVolume) }}</td>
        <td></td>
        <td>{{ getUnitText(MeasurementContext.Area) }}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let option of viewModel.OutputViewModel.VesselOptions.Value"
        [class.ErrorRow]="!option.IsCustom && option.Errors.length > 0"
        [class.CustomRow]="option.IsCustom && option.Errors.length === 0"
        [class.CustomErrorRow]="option.IsCustom && option.Errors.length > 0"
        [class.SelectedRow]="option.Id === viewModel.OutputViewModel.SelectedVesselId.Value"
        >
        <td>
          <input type="checkbox" style="height: 15px;" [checked]="option.Id === viewModel.OutputViewModel.SelectedVesselId.Value" 
            (change)="viewModel.OutputViewModel.SelectedVesselId.Value = option.Id; onChange($event, false);"/>
        </td>
        <td *ngIf="viewModel.OutputViewModel.ShowErrorColumn.Value">
          <mat-icon *ngIf="option.Errors.length > 0" 
            style="vertical-align: middle; color: red;" width="15px" height="15px"
            [matTooltip]="option.ErrorMessages.join('.\n ')"
            matTooltipClass="multiline-tooltip">error</mat-icon>
        </td>
        <td>{{ formatVesselName(option.Vessel) }}</td>
        <td [class.HasCustomOverride]="option?.CustomVessel?.Length">{{ formatUnits(option.Length, MeasurementContext.Length, 0) }}</td>
        <td [class.HasCustomOverride]="option?.CustomVessel?.WallThickness">{{ formatUnits(option.WallThickness, MeasurementContext.Length, 3) }}</td>
        <td>{{ formatUnits(option.TotalCrossSectionArea, MeasurementContext.Area, 2) }}</td>
        <td>{{ formatUnits(option.FreeFlowArea, MeasurementContext.Area, 2) }}</td>
        <td>{{ formatUnits(option.DesignVelocity, MeasurementContext.SeparatorVelocity, 1) }}</td>
        <td>{{ formatUnits(option.DesignMaxVelocity, MeasurementContext.SeparatorVelocity, 1) }}</td>
        <td>{{ formatUnits(option.MinCondensingVelocity, MeasurementContext.SeparatorVelocity, 1) }}</td>
        <td>{{ formatUnits(option.MinCondensingMaxVelocity, MeasurementContext.SeparatorVelocity, 1) }}</td>
        <td [class.HasCustomOverride]="option?.CustomVessel?.OilLevel">{{ formatUnits(option.OilLevel, MeasurementContext.Length, 1) }}</td>
        <td>{{ formatUnits(option.OilCrossSectionArea, MeasurementContext.Area, 2) }}</td>
        <td>{{ formatUnits(option.OilChargeVolume, MeasurementContext.LiquidVolume, 1) }}</td>
        <td  [class.HasCustomOverride]="option?.CustomVessel?.Coalescer">{{ formatCoalescerName(option.Coalescer) }}</td>
        <td>{{ formatUnits(option.Coalescer.SurfaceArea, MeasurementContext.Area, 2) }}</td>
        <td [class.HasCustomOverride]="option?.CustomVessel?.CoalescerQuantity">{{ option.CoalescerQuantity }}</td>
        <td>{{ option.Vessel.CoalescerRods }}</td>
        <td>{{ option.CoalescerRows }}</td>
        <td style="vertical-align: middle;">
          <mat-icon *ngIf="!option.IsCustom" class="ActionIcon" (click)="addNewCustomVessel(option.Vessel.Id)" matTooltip="Copy as New Custom Vessel">content_copy</mat-icon>
          <mat-icon *ngIf="option.IsCustom" class="ActionIcon" (click)="deleteCustomVessel(option.Id)" matTooltip="Delete Custom Vessel">delete</mat-icon>
          <mat-icon *ngIf="option.IsCustom" class="ActionIcon" (click)="editCustomVessel(option.Id)" matTooltip="Edit Custom Vessel">edit</mat-icon>
        </td>
      </tr>
    </tbody>
  </table>

  <!-- Loading Message Modal -->
  <div class="ModalBackground" *ngIf="loadingMessageVisible">
    <div class="ModalDialog">
      <h3 class="Heading">{{ loadingMessage }}</h3>
    </div>
  </div>

  <!-- Custom Vessel Modal -->
  <div class="ModalBackground" *ngIf="showCustomVessel">
    <div class="ModalDialog">
      <h3 class="Heading">{{ customVesselId === 0 ? 'Add New' : 'Edit' }} Custom Vessel</h3>
      <br>

      <span class="InputBlock">
        <span class="Label">Standard Vessel:</span>
        <select class="Value" [(ngModel)]="customStandardVesselId" (change)="onStandardVesselChange($event)">
          <option *ngFor="let x of viewModel.InputViewModel.StandardVessel.AvailableList.Value" [ngValue]="x.Key">{{ x.Value }}</option>
        </select>
        <span class="Unit"></span>
      </span>
      <span class="InputBlock">
        <span class="Label">Length:</span>
        <measurement-text-box class="Value" [(Value)]="customLength" [Context]="MeasurementContext.Length" [IsUsUnits]="isUsUnits"></measurement-text-box>
        <span class="Unit">{{ getUnitText(MeasurementContext.Length) }}</span>
      </span>
      <br>
      <span class="InputBlock">
        <span class="Label">Wall Thickness:</span>
        <measurement-text-box class="Value" [(Value)]="customWallThickness" [Context]="MeasurementContext.Length" [IsUsUnits]="isUsUnits" [UsDecimalPlaces]="3" [SiDecimalPlaces]="3"></measurement-text-box>
        <span class="Unit">{{ getUnitText(MeasurementContext.Length) }}</span>
      </span>
      <span class="InputBlock">
        <span class="Label">Oil Level:</span>
        <measurement-text-box class="Value" [(Value)]="customOilLevel" [Context]="MeasurementContext.Length" [IsUsUnits]="isUsUnits"></measurement-text-box>
        <span class="Unit">{{ getUnitText(MeasurementContext.Length) }}</span>
      </span>
      <span class="InputBlock">
        <span class="Label">Coalescer:</span>
        <select class="Value" [(ngModel)]="customCoalescerId">
          <option *ngFor="let x of viewModel.InputViewModel.Coalescer.AvailableList.Value" [ngValue]="x.Key">{{ x.Value }}</option>
        </select>
        <span class="Unit"></span>
      </span>
      <br>
      <span class="InputBlock">
        <span class="Label">Coalescer Quantity:</span>
        <component-text-box class="Value" [(Value)]="customCoalescerQuantity"></component-text-box>
        <span class="Unit"></span>
      </span>
      <div style="text-align: right;">
        <button class="geaui-button-primary" (click)="saveCustomVessel()">Save</button> &nbsp;
        <button class="geaui-button-secondary" (click)="showCustomVessel = false">Cancel</button>
      </div>
    </div>
  </div>

  <!-- Save Modal -->
  <div class="ModalBackground" *ngIf="showSaveDialog">
    <div class="ModalDialog">
      <h3 class="Heading">Save Calculation</h3>
      <br>
  
      <span class="InputBlock">
        <span class="Label">Project #:</span>
        <component-text-box class="Value" [(Value)]="saveProjectNumber"></component-text-box>
        <span class="Unit"></span>
      </span>
      <span class="InputBlock">
        <span class="Label">Name:</span>
        <component-text-box class="Value" [(Value)]="saveName"></component-text-box>
        <span class="Unit"></span>
      </span>
      <!-- <span class="InputBlock">
        <span class="Label">Comments:</span>
        <component-text-box class="Value" [(Value)]="saveComments"></component-text-box>
        <span class="Unit"></span>
      </span> -->
  
      <div style="text-align: right;">
        <button class="geaui-button-primary" (click)="saveCalculationAsNew()">Save</button> &nbsp;
        <button class="geaui-button-secondary" (click)="showSaveDialog = false">Cancel</button>
      </div>
    </div>
  </div>
  
  <!-- Load Modal -->
  <div class="ModalBackground" *ngIf="showLoadDialog">
    <div class="ModalDialog" style="width: 800px;">
      <h3 class="Heading">Open Calculation</h3>
      <br>
      <span class="InputBlock">
        <span class="Label">Project #:</span>
        <input class="Value" type="text" [(ngModel)]="loadProjectNumber" (keydown)="loadProjectNumberChanged()" [cdkTrapFocus]="true"/>
        <span class="Unit"></span>
      </span>
      <div class="TableWrapperVerticalScroll">
        <table style="width: 700px;">
          <thead class="TableHeadSticky">
            <tr>
              <th></th>
              <th>Project #</th>
              <th>Name</th>
              <th>Created</th>
              <th>Last Modified</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of loadItems" [class.SelectedRow]="item.Id === loadId" (click)="loadId = item.Id" (dblclick)="loadCalculation()">
              <td><input style="height: 15px;" type="checkbox" name="loadItem" [checked]="item.Id === loadId"></td>
              <td>{{ item.ProjectNumber }}</td>
              <td>{{ item.Name }}</td>
              <td>{{ formatDate(item.Created) }}</td>
              <td>{{ formatDate(item.LastModified) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
  
      <div style="text-align: right;">
        <button class="geaui-button-primary" (click)="loadCalculation()">Load</button> &nbsp;
        <button class="geaui-button-secondary" (click)="showLoadDialog = false">Cancel</button>
      </div>
    </div>
  </div>

  <div class="ModalBackground" *ngIf="showNotes">
    <div class="ModalDialog" style="width: 800px; height: 600px;">
      <h3 class="Heading">Notes</h3>
      <br>

      <hrt-comment [comments]="comments" [commentType]="commentType" (commentAdded)="addComment($event)"></hrt-comment>
      <br>
      
      <div style="text-align: right;">
        <button class="geaui-button-secondary" (click)="showNotes = false">Close</button>
      </div>
    </div>
  </div>
  
</div>